import upsell from "../upsell"
import apiDietPaymentProcessor from "../apiDietPaymentProcessor"

const DEFAULT_NUTRITIONIST = "elina"
const NO_NUTRIONIST = "no_coach"

export default (getView) => (nextStepPath, successStepPath, failedStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("chat"),

  isPaymodeModalNeeded: false,
  isPaymodeModalOpen: false,
  activeNutrionist: DEFAULT_NUTRITIONIST,

  saveSelectedNutrionistInStore(nutrionist) {
    this.store.values.selectedChatNutrionist = nutrionist
  },

  init() {
    this.saveSelectedNutrionistInStore(DEFAULT_NUTRITIONIST)
    this.commonInit()

    if (
      !this.store.values.lastPaymentMethod ||
      this.store.values.lastPaymentMethod !== "primer" ||
      !this.store.values.isCardSaved
    ) {
      this.isPaymodeModalNeeded = true
    }
  },

  handleNutrionistChange(nutrionist) {
    this.activeNutrionist = nutrionist
    this.saveSelectedNutrionistInStore(nutrionist)
  },

  async handlePayment(paymode) {
    const { handleCheckoutAndRedirect } = apiDietPaymentProcessor

    // Handle card-save payments
    if (!paymode && !this.isPaymodeModalNeeded) {
      this.loading = true
      const paymentParamsCardSave = {
        successStepPath,
        failedStepPath,
        paymentMethod: "primer",
        restrictCardSave: false,
        checkoutTemplate: "cf-ac-pipe",
      }

      handleCheckoutAndRedirect(paymentParamsCardSave)
      return
    }
    // Open up modal if there is no paymode
    if (!paymode && this.isPaymodeModalNeeded) {
      this.isPaymodeModalOpen = true

      return
    }

    // Handle payments that doesn't have save-card
    this.store.values.lastPaymentMethod = paymode
    this.loading = true
    const paymentParamsWithoutCardSave = {
      successStepPath,
      failedStepPath,
      paymentMethod: paymode,
      restrictCardSave: true,
      checkoutTemplate: "cf-ac-pipe",
    }

    handleCheckoutAndRedirect(paymentParamsWithoutCardSave)
  },

  async handleDecline() {
    this.goToNextUpsellOffer(true)
  },

  onInit() {
    this.initUpsell()
  },

  handleModalClose() {
    this.isPaymodeModalOpen = false
  },
})
